import { FlexBox, Typography, Checkbox, Li } from '@vp/swan';

import React from 'react';
import PropTypes from 'prop-types';

export const DebugFeatureControls = ({
  featureName,
  enabled,
  toggleFeature,
}) => (
  <Li>
    <FlexBox justifyContent="space-between" pl={5} pr={5}>
      <Typography fontSize="small" component="span" mr={7}>
        {featureName}
      </Typography>
      <Checkbox
        checked={enabled}
        onChange={() => toggleFeature({ featureName })}
      />
    </FlexBox>
  </Li>
);

DebugFeatureControls.propTypes = {
  featureName: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  toggleFeature: PropTypes.func,
};
